import { Card, Flex, Typography, Divider } from "antd";

import RefreshIcon from "@/icons/RefreshIcon";

import { getRepeatText } from "@/utils/repeatText";

const PeriodicalSection = ({ repeatRules }) => {
  return (
    <Card>
      <Flex vertical gap={10}>
        <Flex style={{ color: "#aeaeae" }} align="center" gap={5}>
          <RefreshIcon style={{ fontSize: 14 }} />
          <div style={{ marginTop: 2 }}>Периодичность</div>
        </Flex>

        <div>{getRepeatText(repeatRules)}</div>
      </Flex>
      <Divider style={{ borderColor: "#E9E9E9" }} size="middle" />
      <Typography.Text type="secondary">
        Чтобы прекратить создание новых задач, удалите шаблон. Ранее созданные
        задачи останутся в&nbsp;системе без&nbsp;изменений.
      </Typography.Text>
    </Card>
  );
};

export default PeriodicalSection;
